import React from 'react';
import AdminLinkTile from '../../../components/admin/admin-link-tile';

function TemplateSetting() {
return (
    <div className="admin-page-wrap">
        <div className="admin-top-bar-wrap">
            &nbsp;
        </div>
        <div className="admin-page-content">
            <div className="admin-link-tile-wrap setting-page">
                <AdminLinkTile
                    href="/messagetemplate"
                    name="Message Templates"
                />

                <AdminLinkTile
                    href="/automatedmessagetemplate"
                    name="Automated Message Templates"
                />

            </div>

        </div>

    </div>

    );
}

export default TemplateSetting;